(() => {
  if (customElements.get('pet-lettering')) return;
  const STYLES = {
    bebas: { label: 'Bebas Neue', font: 'Bebas Neue', weight: 400, sample: 'Oscar', uppercaseOnly: true },
    urbanist: { label: 'Urbanist', font: 'Urbanist', weight: 800, sample: 'Luna' }
  };
  class PetLettering extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('[data-name]');
      this.key = 'pet3d:v1:' + this.dataset.product;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.key) || '{}');
        if (typeof saved.name === 'string') this.input.value = saved.name.slice(0, 16);
        if (STYLES[saved.style]) this.querySelector('[data-style][value="' + saved.style + '"]').checked = true;
        if (['upper', 'lower'].includes(saved.letterCase)) this.querySelector('[data-case][value="' + saved.letterCase + '"]').checked = true;
      } catch (_) {}
      this.addEventListener('input', () => { this.input.setCustomValidity(''); this.update(); }, options);
      this.addEventListener('change', () => this.update(), options);
      document.addEventListener('submit', event => {
        if (event.target.id !== this.dataset.form) return;
        this.update();
        if (!this.input.value.trim()) this.input.setCustomValidity('Lütfen dostunun adını yaz.');
        if (!this.input.checkValidity()) {
          event.preventDefault(); event.stopImmediatePropagation(); this.input.reportValidity();
        }
      }, { capture: true, signal: this.abort.signal });
      this.update();
      if (document.fonts) document.fonts.ready.then(() => this.fit());
      this.resize = new ResizeObserver(() => this.fit());
      this.resize.observe(this);
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.ready = false; }
    appendTo(formData) {
      if (!this.input.value.trim()) this.input.setCustomValidity('Lütfen dostunun adını yaz.');
      if (!this.input.reportValidity()) return false;
      this.update();
      formData.append('pet_name', this.input.value.trim());
      formData.append('pet_style', this.querySelector('[data-style]:checked').value);
      formData.append('pet_case', this.querySelector('[data-case]:checked').value);
      return true;
    }
    setBusy(busy) {
      this.querySelectorAll('input:not([type="hidden"])').forEach(el => { el.disabled = busy; });
      if (!busy) this.update();
    }
    async applyDesign(url) {
      if (this.dataset.lockedDesign === url) return;
      this.dataset.lockedDesign = url;
      this.setBusy(true);
      try {
        const response = await fetch(url + '?metadata=1');
        if (!response.ok) throw new Error('metadata');
        const saved = await response.json();
        if (!STYLES[saved.style] || !saved.name) { this.setBusy(false); return; }
        this.input.value = saved.name;
        this.querySelector('[data-style][value="' + saved.style + '"]').checked = true;
        this.querySelector('[data-case][value="' + saved.letterCase + '"]').checked = true;
        this.update();
        this.setBusy(true);
      } catch (_) { this.setBusy(false); }
    }
    format(name, letterCase) {
      return letterCase === 'lower' ? name.toLocaleLowerCase('tr-TR') : name.toLocaleUpperCase('tr-TR');
    }
    update() {
      const name = this.input.value.trim().normalize('NFC');
      const id = this.querySelector('[data-style]:checked').value;
      const style = STYLES[id];
      const lowerOption = this.querySelector('[data-case][value="lower"]');
      lowerOption.disabled = !!style.uppercaseOnly;
      if (style.uppercaseOnly) this.querySelector('[data-case][value="upper"]').checked = true;
      const letterCase = this.querySelector('[data-case]:checked').value;
      this.querySelectorAll('[data-sample]').forEach(el => {
        const sampleStyle = STYLES[el.dataset.sample];
        el.textContent = this.format(name || sampleStyle.sample, sampleStyle.uppercaseOnly ? 'upper' : letterCase);
      });
      this.querySelector('[data-count]').textContent = this.input.value.length + ' / 16';
      const values = { name: this.format(name, letterCase), letterCase: letterCase === 'lower' ? 'Tümü küçük' : 'Tümü büyük', style: style.label, font: style.font + ' / ' + style.weight, code: id };
      this.querySelectorAll('[data-property]').forEach(el => { el.value = values[el.dataset.property]; });
      try { sessionStorage.setItem(this.key, JSON.stringify({ name: this.input.value, style: id, letterCase })); } catch (_) {}
      this.fit();
    }
    fit() {
      this.querySelectorAll('[data-sample]').forEach(el => {
        let size = 32;
        el.style.fontSize = size + 'px';
        while (el.scrollWidth > el.clientWidth && size > 5) { size--; el.style.fontSize = size + 'px'; }
      });
    }
  }
  customElements.define('pet-lettering', PetLettering);
})();
